import { ResultStatus, MessageType } from "@/stores/telegramAlerts";

export const getResultLabel = (status: ResultStatus | undefined): string => {
  switch (status) {
    case ResultStatus.WIN:
      return "Ganada";
    case ResultStatus.LOSS:
      return "Perdida";
    case ResultStatus.VOID:
      return "Anulada";
    case ResultStatus.PENDING:
      return "Pendiente";
    case ResultStatus.PROFIT:
      return "Ganancia";
    case ResultStatus.BREAKEVEN:
      return "Breakeven";
    default:
      return "Desconocido";
  }
};

export const getResultBadgeClass = (
  status: ResultStatus | undefined
): string => {
  switch (status) {
    case ResultStatus.WIN:
      return "bg-success";
    case ResultStatus.LOSS:
      return "bg-danger";
    case ResultStatus.VOID:
      return "bg-secondary";
    case ResultStatus.PENDING:
      return "bg-warning";
    case ResultStatus.PROFIT:
      return "bg-success";
    case ResultStatus.BREAKEVEN:
      return "bg-info";
    default:
      return "bg-secondary";
  }
};

export const getMessageTypeLabel = (type?: MessageType): string => {
  switch (type) {
    case MessageType.RESULT:
      return "Resultado";
    case MessageType.UPDATE:
      return "Actualización";
    case MessageType.ADJUSTMENT:
      return "Ajuste";
    case MessageType.MANUAL_CLOSE:
      return "Cierre Manual";
    default:
      return "Mensaje";
  }
};

export const getMessageTypeIcon = (type?: MessageType): string => {
  switch (type) {
    case MessageType.RESULT:
      return "fas fa-flag-checkered";
    case MessageType.UPDATE:
      return "fas fa-sync";
    case MessageType.ADJUSTMENT:
      return "fas fa-edit";
    case MessageType.MANUAL_CLOSE:
      return "fas fa-hand-paper";
    default:
      return "fas fa-comment";
  }
};

export const getConfidenceBadgeClass = (confidence: number): string => {
  if (confidence >= 0.8) return "bg-success";
  if (confidence >= 0.5) return "bg-warning text-dark"; // text-dark only for warning
  return "bg-danger"; // White text by default for danger
};
